import { render } from "./Changelog.vue?vue&type=template&id=ddf380f2&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"

import "./Changelog.vue?vue&type=style&index=0&id=ddf380f2&lang=scss&scoped=true"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf380f2"]])

export default __exports__